// extracted by mini-css-extract-plugin
export var actionButton = "_94-1";
export var actionButtons = "_94-2";
export var actions = "_94-0";
export var aiUnread = "_94-10";
export var alignCenter = "_94-h";
export var backWrapper = "_94-3";
export var cellContainer = "_94-4";
export var checkboxContainer = "_94-5";
export var contentContainer = "_94-6";
export var contentHeader = "_94-8";
export var conversationsTableWrapper = "_94-s";
export var draftReplyBadgeContainer = "_94-m";
export var dropdownItem = "_94-b";
export var dropdownItemsContainer = "_94-a";
export var dropdownTitle = "_94-c";
export var errorIcon = "_94-7";
export var filter = "_94-d";
export var gray = "_94-i";
export var headerActionButtons = "_94-e";
export var headerCheckboxContainer = "_94-f";
export var icon = "_94-j";
export var menuContainer = "_94-k";
export var noMoreTicketsIcon = "_94-12";
export var noMoreTicketsSubText = "_94-13";
export var oneLine = "_94-l";
export var optionsButton = "_94-n";
export var plus = "_94-o";
export var portalButtonsWrapper = "_94-g";
export var red = "_94-p";
export var scrolledTop = "_94-9";
export var search = "_94-q";
export var selectedConversationsCount = "_94-r";
export var spinner = "_94-t";
export var strong = "_94-u";
export var summaryCell = "_94-v";
export var tableContainer = "_94-11";
export var tagContainer = "_94-w";
export var threeDots = "_94-x";
export var twoLines = "_94-y";
export var unread = "_94-z";